<template>
  <div @change="validateSection">
    <header>
      <h3>Discharge</h3>
    </header>

    <div class="content">
      <div class="form__row--x">
        <label>Discharge Date</label>
        <div class="form__row">
          <smd-date-input v-model="dischargeDate"
                          :style="highlightIfError('dischargeDate')"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :disabled="isClose"/>
          <div v-if="$v.dischargeDate.$error" class="error-messages">
            <span v-if="!$v.dischargeDate.notFuture">Cannot be a future date</span>
            <span v-if="!$v.dischargeDate.notTooOld">Cannot be older than 2 years</span>
          </div>
        </div>
      </div>

      <div class="form__row--x" :style="highlightIfError('motherCondition')">
        <label>Patient's Condition</label>
        <div class="form__row">
          <smd-segment type="pill"
                       v-model="motherCondition"
                       :items="$options.motherConditions()"
                       :disabled="isClose"/>
        </div>
      </div>

      <template v-if="motherCondition === 3">
        <div class="form__row--x">
          <label>Cause of Death</label>
          <div class="form__row">
            <select v-model="computedAntecedentType" :style="highlightIfError('antecedentType')" :disabled="isClose">
              <option v-for="mode in antecedentTypes"
                      :value="mode.id"
                      :key="mode.id">
                {{ mode.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Requested to be removed on June 2 meeting revision -->
        <!--
        <div class="form__row--x">
          <label>Underlying Cause</label>
          <div class="form__row">
            <select v-model="antecedentCause" :style="highlightIfError('antecedentCause')" :disabled="isClose">
              <option v-for="mode in antecedentCauses"
                      :value="mode.id"
                      :key="mode.id">
                {{ mode.name }}
              </option>
            </select>
          </div>
        </div>
        -->

        <div class="form__row--x">
          <label>Timing of Death</label>
          <div class="form__row">
            <smd-segment type="pill"
                         v-model="deathTiming"
                         :items="$options.specifics()"
                         :style="highlightIfError('deathTiming')"
                         :disabled="isClose"/>
          </div>
        </div>

      </template>
      <div class="form__row--x" v-if="motherCondition === 3">
        <label>Has case been reviewed by the steering committee/department?</label>
        <div class="form__row">
          <smd-segment type="pill"
                       v-model="deathReviewed"
                       :items="$options.booleanChoices"
                       :style="highlightIfError('deathReviewed')"
                       :disabled="isClose"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {createHelpers} from 'vuex-map-fields'
  import {
    GETTER_CASE_FORM_STATE_FIELD,
    SETTER_CASE_FORM_STATE_FIELD
  } from '../../../store/forms/case-form-state'

  import withSectionValidation from '../../../mixins/with-section-validation'
  import withErrorValidation from '../../../mixins/with-error-validation-mixin';
  import validations from '../../../validations/discharge-section-validation'

  import {
    getMapFn,
    REF_MATERNAL_FETAL_FORM_MOTHER_CONDITION,
    REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE,
    REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_OBJ,
    REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_ANTECEDENTS_OBJ,
    REF_MATERNAL_MORTALITY_IMMEDIATE_CAUSE,
    REF_MATERNAL_MORTALITY_TIMING,
    REF_MATERNAL_MORTALITY_SPECIFIC
  } from '../../../store/modules/referencedata2'

  const {mapFields} = createHelpers({
    getterType: GETTER_CASE_FORM_STATE_FIELD,
    mutationType: SETTER_CASE_FORM_STATE_FIELD
  });

  export default {
    mixins: [withSectionValidation, withErrorValidation],
    computed: {
      ...mapFields([
        'dischargeDate',
        'motherCondition',
        'antecedent',
        'antecedentType',
        'antecedentCause',
        'immediateCause',
        'complicationOnset',
        'complicationOnsetSpecific',
        'deathTiming',
        'deathTimingComplication',
        'immediateCauseOthers',
        'deathReviewed',
        'isClose'
      ]),
      computedAntecedent: {
        get() {
          return this.antecedent
        },
        set(value) {
          this.antecedentCause = null;
          this.antecedentType = null;
          this.antecedent = value
        }
      },
      computedAntecedentType: {
        get() {
          return this.antecedentType
        },
        set(value) {
          //this.antecedentCause = null;
          this.antecedentType = value
        }
      },
      willShowImmediateCauseOthers() {
        return this.immediateCause === 8
      },
      antecedentTypes() {
        let result = getMapFn(REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_OBJ)()[1]
        return result ? result.conditions : []
      },
      antecedentCauses() {
        if (this.antecedentType === null)
          return [];
        else  {
          let result = getMapFn(REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_ANTECEDENTS_OBJ)()[this.antecedentType]
          return result ? result.conditions : []
        }
      },
      minDate() {
        const twoYearsAgo = new Date();
        twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2, 0, 1);
        return twoYearsAgo.toISOString().split('T')[0];
      },
      maxDate() {
        const today = new Date();
        return today.toISOString().split('T')[0];
      },
    },
    motherConditions: getMapFn(REF_MATERNAL_FETAL_FORM_MOTHER_CONDITION),
    antecedentS: getMapFn(REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE),
    immediateCauses: getMapFn(REF_MATERNAL_MORTALITY_IMMEDIATE_CAUSE),
    timing: getMapFn(REF_MATERNAL_MORTALITY_TIMING),
    specifics: getMapFn(REF_MATERNAL_MORTALITY_SPECIFIC),
    booleanChoices: [
      {id: 1, name: 'YES', val: true},
      {id: 2, name: 'NO', val: false}
    ],
    validationSection: 'discharge',
    validations
  }
</script>

<style scoped>
.error-messages {
  color: red;
  font-size: 0.8em;
}
</style>
